<template>
  <div id="app">
    <!-- <router-link to="/">Home</router-link> | -->
    <!-- <router-link to="/about">About</router-link> -->
    <!-- <Home></Home> -->
    <router-view />
  </div>
</template>

<style lang="scss">
@import "~@/assets/all.scss";
// @import "font-awesome/css/font-awesome.min.css";
</style>
<script>
// import Home from "@/views/Home.vue";
// export default {
//   components: {
//     Home,
//   },
// };
</script>
